<template>
  <LayoutGradient :title="$t('review_observation.form.titulo_pagina')" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>    
    <b-overlay :show="isLoadingCurrent" class="m-3 mt-n10" no-center>
      <template v-slot:overlay>
        <div class="d-flex mt-5">
          <div class="m-auto">
            <b-icon icon="stopwatch" font-scale="3" animation="cylon"/>
            <p>Carregando...</p>
          </div>
        </div>
      </template>
      <b-card class="m-3 mt-n10">
        <b-form>
          <b-form-group v-if="reviewObservation.info" label-cols-lg="2" :label="$t('review_observation.form.fieldsets.informacoes')" label-size="lg"
                        label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.recipiente.label')"
            >
              {{ reviewObservation.info.identifier }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.paciente.label')"
            >
              {{ reviewObservation.info.patient_name }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.vns.label')"
            >
              {{ reviewObservation.info.vns_name }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"                
                :label="$t('review_observation.form.fields.empresa.label')"
            >
              {{ reviewObservation.info.company_name }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"                
                :label="$t('review_observation.form.fields.ultima_atualizacao.label')"
            >
              {{ formatDate(reviewObservation.info.updated_at) }}
            </b-form-group>
          </b-form-group>

          <b-form-group 
            v-for="(exam, index) in reviewObservation.exams"
            :key="index"
            label-cols-lg="2" :label="$t('review_observation.form.fieldsets.exames')" label-size="lg"
            label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.exame.label')"
            >              
              {{ exam.exam || exam.exam_code }}
              <b-btn v-if="!btnIndex[index]" variant="outline-primary border-0" pill @click="editReviewObservation(index, exam)">
                <i class="fas fa-edit"/>
              </b-btn>
              <b-btn v-if="btnIndex[index]" variant="outline-danger border-0" pill @click="clearEditReviewObservation(index, exam)">
                <i class="fas fa-ban"/>
              </b-btn>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.exame_ordem.label')"
            >
              {{ exam.parent_exam_mapped_code }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.material.label')"
            >
              {{ exam.specimen_mapped_code }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.resultado.label')"
            >
              {{ exam.value_quantity_value }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('review_observation.form.fields.unidade_medida.label')"
            >
              {{ exam.value_quantity_unit }}
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('review_observation.form.fields.edit.resultado.description')"
                :label="$t('review_observation.form.fields.edit.resultado.label')"
                label-for="input-edit-value_quantity_value"
                v-if="btnIndex[index]"
            >
              <b-form-input id="input-edit-value_quantity_value" v-model="reviewObservationEdit[index].value_quantity_value"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('review_observation.form.fields.edit.unidade_medida.description')"
                :label="$t('review_observation.form.fields.edit.unidade_medida.label')"
                label-for="input-edit-value_quantity_unit"
                v-if="btnIndex[index]"
            >
              <b-form-input id="input-edit-value_quantity_unit" v-model="reviewObservationEdit[index].value_quantity_unit"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                description=""
                :label="$t('review_observation.form.fields.erro_mapeamento.label')"
                label-for="alert"
                v-if="!exam.exam || !exam.parent_exam_mapped_code || !exam.specimen_mapped_code"
            >
                <b-alert show variant="danger">{{ exam.exam_code }} - {{ $t('review_observation.form.fields.erro_mapeamento.mensagem') }}</b-alert>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('review_observation.form.fields.edit.motivo.description')"
                :label="$t('review_observation.form.fields.edit.motivo.label')"
                label-for="input-edit-reason"
                v-if="btnIndex[index]"
            >
              <b-form-textarea id="input-edit-reason"
                v-model="reviewObservationEdit[index].reason"
                maxlength="500"
                rows="4"
                max-rows="6">
              </b-form-textarea>
              <small class="text-muted">
                {{ reviewObservationEdit[index].reason.length }}/500 caracteres
              </small>
            </b-form-group>
          </b-form-group>
          <div class="d-flex justify-content-between align-items-center">
            <b-button v-if="reviewObservation.info" @click="cancelExamsFromReport()" variant="danger">
              <i class="fas fa-ban"/> {{ $t('review_observation.form.fields.cancelar_resultados') }}
            </b-button>            
            <b-button v-if="reviewObservation.info && isResultsSavable" @click="onSubmit()" variant="success">
              <i class="fas fa-save"/> {{ $t('review_observation.form.fields.botao_salvar') }}
            </b-button>
            <b-button v-if="reviewObservation.info && isResultsSavable" @click="onSubmitAndNext()" variant="success">
              <i class="fas fa-arrow-right"/> {{ $t('review_observation.form.fields.botao_salvar_proximo') }}
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient"
import Loading from "@/components/Loading";
import ReviewObservationRepository from '@/repositories/ReviewObservationRepository'
import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import Cookies from 'js-cookie'

export default {
  name: "Form",
  components: {
    Loading,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      reviewObservation: 'reviewObservation/current',
      storeIsLoading: 'reviewObservation/isLoading',
    }),
    isLoadingCurrent() {
      return !(this.mounted && this.storeIsLoading === false)
    },
    isResultsSavable() {
      let savable = true;
      this.reviewObservation.exams.forEach(element => {
        if (!element.exam || !element.parent_exam_mapped_code || !element.specimen_mapped_code) {
          savable = false;
        }
      });

      return savable;
    }
  },
  data() {
    return {
      mounted: false,
      reportId: null,
      btnIndex: [],
      reviewObservationEdit: [],
      currentUserId: null,
    }
  },
  methods: {
    ...mapActions([      
      'reviewObservation/listOne',
      'reviewObservation/listNext'
    ]),
    setReviewObservation(key, value) {
      this.$store.commit('reviewObservation/setCurrent', {...this.reviewObservation, [key]: value})
    },
    editReviewObservation(index, exam) {
      let observationEdit = {
        id: exam.id,
        value_quantity_value: exam.value_quantity_value,
        value_quantity_unit: exam.value_quantity_unit,
        reason: '',
      }
      this.$set(this.reviewObservationEdit, index, observationEdit)
      this.$set(this.btnIndex, index, true)
    },
    clearEditReviewObservation(index, exam) {
      this.$delete(this.reviewObservationEdit, index)      
      this.$set(this.btnIndex, index, false);
    },
    async onSubmit() {      
      let savedAndSended = await this.update()
      if (savedAndSended) {
        this.$router.push({name: 'review_observation.index'});
      }
    },
    async onSubmitAndNext() {
      let savedAndSended = await this.update()
      if (savedAndSended) {
        this.$router.push({name: 'review_observation.next'});
      }
    },
    async cancelExamsFromReport() {
      this.$store.commit('reviewObservation/setLoading', true)

      return await ReviewObservationRepository.cancel(this.reportId).then(() => {
        this.$store.commit('reviewObservation/setLoading', false)        
        this.$snotify.warning(this.$t('review_observation.form.cancel.success'), {timeout: 8000})
        this.$router.push({name: 'review_observation.index'});
      }).catch(error => {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.cancel.error'), {timeout: 8000})
        if (error.response.status === 422) {
          ReviewObservationRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async fetchForRoute() {
      this.$store.commit('reviewObservation/setCurrent', {})
      this.$store.commit('reviewObservation/setLoading', true)
      this.reportId = this.$route.params.id
      if (this.reportId) {        
        await this['reviewObservation/listOne'](this.reportId).then((response) => {          
          if (this.reviewObservation.info === undefined || this.reviewObservation.info.edited_by_user_id !== this.currentUserId) {
            this.$store.commit('reviewObservation/setLoading', false)
            this.$snotify.info(this.$t('review_observation.form.sem_resultados'), {timeout: 8000})
            this.$router.push({name: 'review_observation.index'});
            return
          }
          
          this.mounted = true
        }).catch(error => {
          this.$store.commit('reviewObservation/setLoading', false)
          this.$snotify.error(this.$t('review_observation.form.list.error'), {timeout: 8000})
          if (error.response.status === 422) {
            ReviewObservationRepository.toastValidationErrors(error, this.$snotify)
          }
        })
      } else {
        await this['reviewObservation/listNext']().then((response) => {
          if (response === undefined) {
            this.$store.commit('reviewObservation/setLoading', false)
            this.$snotify.warning(this.$t('review_observation.form.outro_usuario'), {timeout: 8000})
            this.$router.push({name: 'review_observation.index'});
            return
          }
          this.mounted = true
        }).catch(error => {
          this.$store.commit('reviewObservation/setLoading', false)
          this.$snotify.error(this.$t('review_observation.form.list.error'), {timeout: 8000})
          if (error.response.status === 422) {
            ReviewObservationRepository.toastValidationErrors(error, this.$snotify)
          }
        })
      }      
    },
    validateObservation(observation) {
      if (!observation) {
        return true;
      }

      if (observation.value_quantity_value.trim().length === 0) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.resultado_required'), {timeout: 8000})
        return false  
      }

      if (observation.value_quantity_value.trim().length === 255) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.resultado_maxlength'), {timeout: 8000})
        return false  
      }

      if (observation.value_quantity_unit.trim().length === 0) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.unidade_medida_required'), {timeout: 8000})
        return false  
      }

      if (observation.value_quantity_unit.trim().length === 255) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.unidade_medida_maxlength'), {timeout: 8000})
        return false  
      }

      if (observation.reason.trim().length === 0) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.motivo_required'), {timeout: 8000})
        return false  
      }

      if (observation.reason.trim().length > 500) {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.validation.motivo_maxlength'), {timeout: 8000})
        return false  
      }

      return true
    },
    async update() {
      this.$store.commit('reviewObservation/setLoading', true)

      let reviewObservationEditable = this.reviewObservationEdit.filter(observation => observation !== undefined)

      const validRequest = reviewObservationEditable.every(observation => {
        return this.validateObservation(observation);
      });

      if (!validRequest) {
        return false;
      }      

      return await ReviewObservationRepository.put(this.reportId, { exams: reviewObservationEditable }).then(() => {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.success(this.$t('review_observation.form.update.success'), {timeout: 8000})
        this.$snotify.warning(this.$t('review_observation.form.update.warning'), {timeout: 8000})
        return true
      }).catch(error => {
        this.$store.commit('reviewObservation/setLoading', false)
        this.$snotify.error(this.$t('review_observation.form.update.error'), {timeout: 8000})
        if (error.response.status === 422) {
          ReviewObservationRepository.toastValidationErrors(error, this.$snotify)
        }
        return false
      })
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    }
  },
  async mounted() {
    this.currentUserId = Cookies.get('veus_usuario_id')
    await this.fetchForRoute()
  },
  watch: {
    '$route'(to, from) {
      this.fetchForRoute().catch(err => console.error(err))
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
